import { z } from 'zod';
import { OrganizationError } from 'libs/end-to-end/src/types/errors/organization-error';
import { UnknownError } from 'libs/end-to-end/src/types/errors/unknown-error';
import { UserEmailNotFoundError } from 'libs/end-to-end/src/types/errors/user-email-not-found-error';
import { UserNotAdminOfOrganizationError } from 'libs/end-to-end/src/types/errors/user-not-admin-of-organization-error';
import { UserNotFoundError } from 'libs/end-to-end/src/types/errors/user-not-found-error';
import { UserNotInOrganizationError } from 'libs/end-to-end/src/types/errors/user-not-in-organization-error';
import { UserUpdateError } from 'libs/end-to-end/src/types/errors/user-update-error';
import { AuthError } from 'libs/end-to-end/src/types/errors/auth-error';
import { RdbmsError } from 'libs/end-to-end/src/types/errors/rdbms-error';

export const UserError = z.union([
  AuthError,
  UserNotFoundError,
  UserUpdateError,
  UserEmailNotFoundError,
  UserNotInOrganizationError,
  UserNotAdminOfOrganizationError,
  OrganizationError,
  UnknownError,
  RdbmsError,
]);

export type UserError = z.infer<typeof UserError>;
